import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// This design system's typography scale is exposed as Tailwind v4 `text-*`
// utilities via @theme (globals.css) — e.g. `text-caption-regular`,
// `text-body-sm-medium`, `text-heading-h6`. tailwind-merge's built-in
// class-group detection has no way to know these are FONT-SIZE utilities
// rather than text-COLOR ones (both share the `text-` prefix), so whenever a
// component's classes mix one of these with a real color utility (e.g.
// `text-primary-foreground`), tailwind-merge treats them as conflicting and
// silently drops whichever came first — the exact cause of a
// black-text-on-black-background Button (`variant="default" size="xs"`:
// `text-primary-foreground` from the variant lost to `text-caption-regular`
// from the size). Registering the scale under the `font-size` group fixes
// this at the root instead of patching every affected call site.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'heading-h1',
            'heading-h2',
            'heading-h3',
            'heading-h4',
            'heading-h5',
            'heading-h6',
            'heading-h7',
            'body-lg-regular',
            'body-md-regular',
            'body-sm-regular',
            'body-md-medium',
            'body-md-semibold',
            'body-sm-medium',
            'body-sm-semibold',
            'caption-regular',
            'caption-medium',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
